export const ORDER_OPTIONS = {
  'months-days-years': 'M|D|Y',
  'months-years-days': 'M|Y|D',
  'years-days-months': 'Y|D|M',
  'days-months-years': 'D|M|Y',
  'years-months-days': 'Y|M|D',
}

export const MONTHS_OPTIONS = {
  '1-12': '1-12',
  '01-12': '01-12',
  'Jan-Dec': 'Jan-Dec',
  'January-December': 'January-December',
  None: 'None',
}

export const DAYS_OPTIONS = {
  '1-31': '1-31',
  '01-31': '01-31',
  None: 'None',
}

export const YEARS_OPTIONS = {
  '00-99': '00-99',
  '0000-9999': '0000-9999',
  None: 'None',
}

export const DELIMITER_OPTIONS = {
  '|': '|',
  '/': '/',
  '-': '-',
  '\\': '\\',
  '': 'None',
  custom: 'Custom',
}

export const FORMAT_STRINGS_CONVERSIONS = {
  orders: {
    'months-days-years': { days: 1, months: 0, years: 2 },
    'months-years-days': { days: 2, months: 0, years: 1 },
    'years-days-months': { days: 1, months: 2, years: 0 },
    'days-months-years': { days: 0, months: 1, years: 2 },
    'years-months-days': { days: 2, months: 1, years: 0 },
  },
  days: {
    '1-31': 'D',
    '01-31': 'DD',
    None: '',
  },
  months: {
    '1-12': 'M',
    '01-12': 'MM',
    'Jan-Dec': 'MMM',
    'January-December': 'MMMM',
    None: '',
  },
  years: {
    '00-99': 'YY',
    '0000-9999': 'YYYY',
    None: '',
  },
}

export const convertDateFieldToMomentJsFormat = field => {
  const { date, delimiter } = field
  const hasFormat = !!date.order
  const dayFormat = FORMAT_STRINGS_CONVERSIONS.days[date.days]
  const monthFormat = FORMAT_STRINGS_CONVERSIONS.months[date.months]
  const yearFormat = FORMAT_STRINGS_CONVERSIONS.years[date.years]
  const order = FORMAT_STRINGS_CONVERSIONS.orders[date.order]

  if (hasFormat) {
    const dateParts = []
    dateParts[order.days] = dayFormat
    dateParts[order.months] = monthFormat
    dateParts[order.years] = yearFormat

    return dateParts.filter(dp => !!dp).join(delimiter ? `${delimiter}` : '')
  }

  return null
}

export function toSelectOptions(OPTIONS) {
  return Object.keys(OPTIONS).map(key => {
    return {
      key,
      value: key,
      display: OPTIONS[key],
    }
  })
}
